<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3HSm16/tc-custom/9781512489958.jpg?1718183631728" alt="This image is the cover for the book It's Purim Time!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Purim Time!
      </h1>
      <p class="bookDescription body article font2">
        <p>In the fifth of Kar-Ben's popular holiday series, preschoolers dress up and act out the story of Purim, make groggers (noise makers) and hamentaschen (three-cornered cookies), and deliver <i>shalach manot </i>(Purim treats).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Latifa Berry Kropf, Tod Cohen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?716f5e48